import React, { createContext, useState, useEffect } from 'react'
import en from './en.json'
import th from './th.json'
import dayjs from 'dayjs'
import "dayjs/locale/en"
import "dayjs/locale/th"
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enPicker from 'date-fns/locale/en-US'
import thPicker from 'date-fns/locale/th'

registerLocale("en", enPicker)
registerLocale("th", thPicker)

const LanguageContext = createContext()
const langConstant = {
    EN: "en",
    TH: "th"
}

function useLanguage(){
    const [lang, setLang] = useState(th)
    const [code, setCode] = useState(langConstant.TH)

    const switchLanguage = (code, lang) =>{
        localStorage.setItem("language", code)
        dayjs.locale(code)
        setCode(code)
        setDefaultLocale(code)
        setLang(lang)
    }

    useEffect(()=>{
        localStorage.setItem("language", langConstant.TH)
        let saveLocale = localStorage.getItem("language")
        console.log(saveLocale)
        switch(saveLocale){
            case(langConstant.TH):
                switchLanguage(langConstant.TH, th)
                break;
            default:
                switchLanguage(langConstant.EN, en)
                break;
        }
    },[])

    const setLanguage = (toLang) =>{
        switch(toLang){
            case(langConstant.TH):
                switchLanguage(langConstant.TH, th)
                break;
            default:
                switchLanguage(langConstant.EN, en)
                break;
        }
    }

    return { lang, code, setLanguage }
}

function LanguageProvider(props){
    const langValue = useLanguage()

    return(
        <LanguageContext.Provider value={langValue}>
            {props.children}
        </LanguageContext.Provider>
    )
}

export { LanguageContext, langConstant, LanguageProvider }